export default __webpack_public_path__ + "static/media/spoons.b0ba69d6.jpg";